import { Component, input, computed } from '@angular/core';
import { ScheduleSummary, IconComponent } from '@net3-multiplatform-client/libs';

@Component({
  selector: 'lib-schedule-summary',
  imports: [IconComponent],
  templateUrl: './schedule-summary.html',
})
export class ScheduleSummaryComponent {
  schedules = input<ScheduleSummary[]>([]);
  title = input<string>('Previsiones pendientes');

  scheduleSummary = computed(() => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const todayTime = today.getTime();

    const map = new Map<string, any>();

    this.schedules().forEach((s) => {
      if (s.value <= 0) return;

      const date = new Date(s.irrigationDate);

      // només dates d'avui i futures
      if (date.getTime() < todayTime) return;

      const dayNumber = date.getDate();
      const dayName = date.toLocaleDateString('es-ES', { weekday: 'long' });
      const monthYear = date.toLocaleDateString('es-ES', { month: 'short', year: 'numeric' });

      // format temps HH:mm
      const hours = Math.floor(s.value / 60);
      const minutes = s.value % 60;
      const formattedValue = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;

      map.set(s.irrigationDate, {
        date: s.irrigationDate,
        dayNumber,
        dayName,
        monthYear,
        minutes,
        hours,
        formattedValue,
        value: s.value,
      });
    });

    const daily = Array.from(map.values()).sort((a, b) => a.date.localeCompare(b.date));
    const totalValue = daily.reduce((acc, item) => acc + item.value, 0);

    const totalHours = Math.floor(totalValue / 60);
    const remainingMinutes = totalValue % 60;
    const totalFormatted = `${totalHours.toString().padStart(2, '0')}:${remainingMinutes.toString().padStart(2, '0')}`;

    return {
      daily,
      totalDays: daily.length,
      totalFormatted,
      totalHours: totalHours.toString().padStart(2, '0'),
      totalMinutes: remainingMinutes.toString().padStart(2, '0'),
    };
  });
}